import { all, put, takeLatest } from 'redux-saga/effects'

import { getBaseUrl } from 'helpers/fuctions'

import { actionTypes } from '../actions'

function* fetchRequest({ orderId, baseUrl }) {
  const _baseUrl = getBaseUrl(orderId, baseUrl)

  try {
    const res = yield fetch(`${_baseUrl}/jobs/${orderId}.json`)
    const data = yield res.json()
    yield put({
      type: actionTypes.FETCH_SUCCESS,
      payload: { ...data, notFound: res.status === 404 },
    })
  } catch (err) {
    console.log(err)
  }
}

function* themeRequest({ orderId, baseUrl }) {
  const _baseUrl = getBaseUrl(orderId, baseUrl)

  try {
    const orderRequest = yield fetch(`${_baseUrl}/jobs/${orderId}.json`)
    const orderResponse = yield orderRequest.json()
    const res = yield fetch(`${_baseUrl}/demo/${orderResponse.business.uuid}`)
    const data = yield res.json()
    yield put({ type: actionTypes.THEME_LOADED, payload: data })
  } catch (error) {
    console.log(
      'Failed to load theme: ',
      error,
      '; Try to get theme using jobs api',
    )
    const res = yield fetch(`${_baseUrl}/demo/${orderId}`)
    const data = yield res.json()
    yield put({ type: actionTypes.THEME_LOADED, payload: data })
  }
}

function* fetchFeedback({ orderId, baseUrl }) {
  const _baseUrl = getBaseUrl(orderId, baseUrl)

  try {
    const res = yield fetch(`${_baseUrl}/jobs/${orderId}/feedback/questions`)
    const data = yield res.json()
    yield put({ type: actionTypes.FETCH_FEEDBACK_SUCCESS, payload: data })
  } catch (err) {
    console.log(err)
  }
}

function* fetchInternal({ payload, baseUrl }) {
  const _baseUrl = getBaseUrl('', baseUrl)

  try {
    const orderRes = yield fetch(
      `${_baseUrl}/jobs/search?account_uuid=${payload.account_uuid}&partners_unique_internal_order_id=${payload.partners_unique_internal_order_id}`,
    )
    const orderId = yield orderRes.json()
    const res = yield fetch(
      `${getBaseUrl(orderId.uuid, baseUrl)}/jobs/${orderId.uuid}.json`,
    )
    const data = yield res.json()
    yield put({ type: actionTypes.FETCH_SUCCESS, payload: data })
  } catch (error) {
    console.error('FETCH INTERNAL API ERROR', error)
  }
}

function* rootSaga() {
  // yield takeLatest(actionTypes.FETCH_REQUEST, fetchRequest);
  yield all([takeLatest(actionTypes.FETCH_REQUEST, fetchRequest)])
  yield all([takeLatest(actionTypes.THEME_REQUEST, themeRequest)])
  yield all([takeLatest(actionTypes.FETCH_FEEDBACK_REQUEST, fetchFeedback)])
  yield all([takeLatest(actionTypes.FETCH_REQUEST_INTERNAL, fetchInternal)])
}

export default rootSaga
